import { useState, useEffect } from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import Button from "@mui/material/Button";
import { Tooltip } from "@mui/material";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import API from "../API";
import DOMPurify from "dompurify";
import RichTextEditor from "../../UtilComponents/RichTextEditor";

export default function VisaProcessingTime() {

  const [searchTerm, setSearchTerm] = useState("");
  const [visaProcess, setVisaProcess] = useState([]);
  const [page, setPage] = useState(0);
  const [openModal, setOpenModal] = useState(false);
  const [openDeleteModal, setopenDeleteModal] = useState(false);
  const [countryInput, setCountryInput] = useState("");
  const [noteInput, setNoteInput] = useState("");
  const [deleteId, setDeleteId] = useState("");
  const [visaType, setVisaType] = useState("");
  const [processingTime, setProcessingTime] = useState("");
  const [editId, setEditId] = useState("");
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
    display: "flex",
    flexDirection: "column",
  };

  useEffect(() => {
    fetchvisaProcess();
  }, []);

  const fetchvisaProcess = async () => {
    try {
      const response = await API.get(
        "/visaprocessing/getVisaProcessingRecords"
      );
      setVisaProcess(response?.data?.combinedProcessingTime);
    } catch (error) {
      console.error(error)
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleSearchInputChange = (event) => {
    setSearchTerm(event.target.value);
    setPage(0)
  };
  const filteredvisaProcess = Object.values(visaProcess).filter((requirement) =>
    requirement.country.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleOpenModal = () => {
    setOpenModal(true);
    setCountryInput("");
    setProcessingTime("");
    setVisaType("");
    setNoteInput("");
    setEditId("");    
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setCountryInput("");
    setNoteInput("");
  };
  const handleAddNewCountry = async () => {
    // Add your logic to handle adding a new country here
    const response = await API.post("/visaprocessing/addVisaProcessingRecord", {
      country: countryInput,
      visa_type: visaType,
      processing_time: processingTime,
      notes: noteInput,
    });
    if (response.status === 200) {
      window.location.reload();
    }
  };
  const handleEditCountry = async (_id) => {
    // Add your logic to handle editing a country here
    try {
      const response = await API.patch(
        `/visaprocessing/editVisaProcessingRecord/${_id}`,
        {
          country: countryInput,
          notes: noteInput,
          processing_time: processingTime,
          visa_type: visaType,
        }
      );
      if (response.status === 200) {
        window.location.reload();
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleDeleteEvisa = async () => {
    const response = await API.post(
      `/visaprocessing/deleteVisaProcessingRecord/${deleteId}`
    );
    if (response.status === 200) {
      window.location.reload();
    }
  };

  const handleOpenEditModal = (
    country,
    _id,
    visa_type,
    processingTime,
    remarks
  ) => {
    setOpenModal(true);
    setCountryInput(country);
    setProcessingTime(processingTime);
    setVisaType(visa_type);
    setNoteInput(remarks);
    setEditId(_id);
  };

  const handleOpenDeleteModal = (_id) => {
    setopenDeleteModal(true);
    setDeleteId(_id);
  };

  const handleCloseDeleteModal = (_id) => {
    setDeleteId("");
    setopenDeleteModal(false);
  };

  const handleCountryInputChange = (event) => {
    setCountryInput(event.target.value);
  };

  const truncatedValue = (value, totalLength) => {
    if (value && value.length > totalLength) {
      return value.substring(0, totalLength) + "...";
    }
    return value;
  };

  const SafeHtml = ({ htmlContent }) => {
    // Sanitize the HTML content
    const sanitizedHtml = DOMPurify.sanitize(htmlContent);

    return <div dangerouslySetInnerHTML={{ __html: sanitizedHtml }} />;
  };

  return (
    <Paper>
      <Box
        sx={{
          padding: 2,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "300px",
        }}
      >
        <TextField
          fullWidth
          label="Search by Country"
          variant="outlined"
          value={searchTerm}
          onChange={handleSearchInputChange}
        />
      </Box>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Updated At</TableCell>
              <TableCell>Country</TableCell>
              <TableCell>Visa Type</TableCell>
              <TableCell>Visa Processing Time</TableCell>
              <TableCell>Latest Application Processing Time</TableCell>
              <TableCell>Latest Application Date</TableCell>
              <TableCell>Remarks</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredvisaProcess
              .slice(page * 10, page * 10 + 10)
              .map((requirement) => (
                <TableRow key={requirement.key}>
                  <TableCell>{requirement?.updatedAt?
                  new Date(requirement.updatedAt).toLocaleDateString("en-GB", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                  }):''}</TableCell>
                  <TableCell>{requirement?.country}</TableCell>
                  <TableCell>{requirement?.visa_type}</TableCell>
                  <TableCell>{requirement?.processing_time}</TableCell>
                  <TableCell>{requirement?.processing_time_days?`${requirement.processing_time_days} days`:''}</TableCell>
                  <TableCell>{requirement?.appointment_date?
                    new Date(
                      requirement.appointment_date
                    ).toLocaleDateString("en-GB", {
                      day: "2-digit",
                      month: "2-digit",
                      year: "numeric",
                    }):''}
                  </TableCell>
                  <TableCell>
                    <Tooltip title="Remarks" placement="top" arrow>
                      <SafeHtml
                        htmlContent={truncatedValue(requirement?.remarks, 100)}
                      />
                    </Tooltip>
                  </TableCell>
                  <TableCell>
                    <Button
                      variant="contained"
                      color="secondary"
                      onClick={() =>
                        handleOpenEditModal(
                          requirement.country,
                          requirement._id,
                          requirement.visa_type,
                          requirement.processing_time,
                          requirement.remarks
                        )
                      }
                    >
                      Edit
                    </Button>
                    <Button
                      className="m-2"
                      variant="contained"
                      color="secondary"
                      onClick={() => handleOpenDeleteModal(requirement._id)}
                    >
                      Delete
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10]}
        component="div"
        count={Object.values(visaProcess).length}
        rowsPerPage={10}
        page={page}
        onPageChange={handleChangePage}
      />
      <div style={{ position: "fixed", bottom: "10px", left: "10px" }}>
        <Button variant="contained" color="primary" onClick={handleOpenModal}>
          Add New Country
        </Button>
      </div>
      <Modal open={openModal} onClose={handleCloseModal}>
        <Box sx={style}>
          <TextField
            label="Country"
            value={countryInput}
            onChange={handleCountryInputChange}
            style={{ marginBottom: "10px" }}
          />
          <TextField
            label="VisaType"
            value={visaType}
            onChange={(e) => setVisaType(e.target.value)}
            style={{ marginBottom: "10px" }}
          />
          <TextField
            label="Processing Time"
            value={processingTime}
            onChange={(e) => setProcessingTime(e.target.value)}
            style={{ marginBottom: "10px" }}
          />
          <RichTextEditor
            htmlContent={noteInput}
            setHTMLContent={setNoteInput}
            style={{ marginBottom: "10px" }}
            placeholder={"Enter notes here"}
          />
          <Button
            variant="contained"
            color="primary"
            onClick={() => {editId?handleEditCountry(editId):handleAddNewCountry()}}
          >
            {editId?'Save':'Add'}
            
          </Button>
        </Box>
      </Modal>
      <Modal open={openDeleteModal} onClose={handleCloseDeleteModal}>
        <Box sx={style}>
          <h3 className="m-4">Please confirm to delete </h3>
          <Button
            variant="contained"
            color="primary"
            onClick={() => handleDeleteEvisa(deleteId)}
          >
            Delete
          </Button>
        </Box>
      </Modal>
    </Paper>
  );
}